// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D3JveK {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  border: 1px solid var(--avatar-border-color);
  background-color: var(--avatar-bg);
  font-family: var(--font-family-base, 'Source Sans 3, sans-serif');
  font-weight: 400;
  text-align: center;
  color: var(--avatar-text-color);
  text-transform: uppercase;
  position: relative;
  overflow: hidden;
  line-height: 1.424;
}

.WAMpV_ {
  width: 24px;
  height: 24px;
  font-size: 10px;
}

.Wfvu3g {
  width: 32px;
  height: 32px;
  font-size: 12px;
}

.TNveDe {
  width: 48px;
  height: 48px;
  font-size: 16px;
}

.jlMML_ {
  outline: 2px solid var(--avatar-focus-color);
  outline-offset: 2px;
}

.YgRl6j {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 100px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Avatar/Avatar.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,4CAA4C;EAC5C,kCAAkC;EAClC,iEAAiE;EACjE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":[".avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100px;\n  border: 1px solid var(--avatar-border-color);\n  background-color: var(--avatar-bg);\n  font-family: var(--font-family-base, 'Source Sans 3, sans-serif');\n  font-weight: 400;\n  text-align: center;\n  color: var(--avatar-text-color);\n  text-transform: uppercase;\n  position: relative;\n  overflow: hidden;\n  line-height: 1.424;\n}\n\n.avatarSmall {\n  width: 24px;\n  height: 24px;\n  font-size: 10px;\n}\n\n.avatarMedium {\n  width: 32px;\n  height: 32px;\n  font-size: 12px;\n}\n\n.avatarLarge {\n  width: 48px;\n  height: 48px;\n  font-size: 16px;\n}\n\n.avatarFocused {\n  outline: 2px solid var(--avatar-focus-color);\n  outline-offset: 2px;\n}\n\n.avatarImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar": `D3JveK`,
	"avatarSmall": `WAMpV_`,
	"avatarMedium": `Wfvu3g`,
	"avatarLarge": `TNveDe`,
	"avatarFocused": `jlMML_`,
	"avatarImage": `YgRl6j`
};
module.exports = ___CSS_LOADER_EXPORT___;
